import type { WidgetCoreDefinition, TeXMLContext, TeXMLElement, ValidationResult } from './types';
import { buildCallbackUrl } from './types';

export type TransferToQueueConfig = {
  queueId: string;
  queueName: string;
  priority: number;
  announcePosition: boolean;
};

function generateTeXML(config: TransferToQueueConfig, context: TeXMLContext): TeXMLElement[] {
  return [
    {
      tag: 'Redirect',
      attributes: { method: 'POST' },
      content: buildCallbackUrl(context),
    },
  ];
}

function validateConfig(config: TransferToQueueConfig): ValidationResult {
  const errors: string[] = [];

  if (!config.queueId) {
    errors.push('Queue is required');
  }

  if (config.priority < -10 || config.priority > 10) {
    errors.push('Priority must be between -10 and 10');
  }

  return { valid: errors.length === 0, errors };
}

export const transferToQueueWidgetCore: WidgetCoreDefinition<TransferToQueueConfig> = {
  id: 'transferToQueue',
  version: 1,
  name: 'Transfer to Queue',
  description: 'Route the call to a queue for agent handling',
  category: 'routing',
  tier: 'premium',

  defaultConfig: {
    queueId: '',
    queueName: '',
    priority: 0,
    announcePosition: true,
  },

  texml: {
    generate: generateTeXML,
    requiresCallback: true,
  },

  validation: {
    validateConfig,
  },
};
